import { useCallback } from 'react';
import { withScrollRestoration } from '@/shared/hocs/withScrollRestoration';
import { ExtendedAddress } from '../types';

interface ValidAddressFromFormikValuesProps {
    values: ExtendedAddress;
    hasEdit?: boolean;
    onEditPressed?: () => void;
}

const ValidAddressFromFormikValues: React.FC<ValidAddressFromFormikValuesProps> = ({ values, hasEdit = true, onEditPressed }) => {
    const localOnEditPressed = useCallback(() => {
        onEditPressed?.();
    }, [onEditPressed]);

    return (
        <div className="flex w-full max-w-full items-start rounded-2xl border-1 border-black p-5 lg:py-[1.4375rem] lg:pl-[1.5625rem] lg:pr-5">
            <div className="max-w-full flex-auto">
                <h4 className="mb-[4px] w-full overflow-hidden text-ellipsis whitespace-nowrap font-atkinsonBold text-base uppercase text-black md:text-lg sm-max:text-[0.8125rem]">
                    {values.addressLine1} {values.addressLine2}
                </h4>
                <div className="flex max-w-full flex-col gap-0.5 overflow-hidden">
                    {values.unit && (
                        <span className="w-full max-w-full overflow-hidden text-ellipsis whitespace-nowrap break-all font-atkinsonHyperlegible text-sm uppercase lg:text-base">
                            {values.unit}
                        </span>
                    )}

                    <span className="w-full max-w-full overflow-hidden text-ellipsis whitespace-nowrap break-all font-atkinsonHyperlegible text-sm uppercase lg:text-base">
                        {values.city}, {values.state} {values.zip}
                    </span>
                    {/* <span className="break-all font-atkinsonHyperlegible text-sm uppercase lg:text-base">{values.zip}</span> */}
                </div>
            </div>
            {hasEdit && (
                <i
                    onClick={localOnEditPressed}
                    className="icon-pen flex h-[35px] min-w-[35px] cursor-pointer items-center justify-center rounded-full bg-mint-400 text-base text-primary-800"
                />
            )}
        </div>
    );
};

export default withScrollRestoration(ValidAddressFromFormikValues);
